<script>
    import { createEventDispatcher } from 'svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'

    export let data
    export let index

    let dispatchTimer = null

    const dispatch = createEventDispatcher ();

    const onNameChange = event => {
        data.name = event.detail.value;
        dispatchChange ();
    }

    const onStreetChange = event => {
        data.street = event.detail.value;
        dispatchChange ();
    }

    const onCityChange = event => {
        data.city = event.detail.value;
        dispatchChange ();
    }

    const deleteItem = () => {
        dispatch ('remove', { index })
    }

    const dispatchChange = () => {
        if (dispatchTimer) {
            clearTimeout (dispatchTimer);
            dispatchTimer = null
        }

        dispatchTimer = setTimeout (() => {
            dispatch ('change', {
                index,
                value: data
            })
        }, 500)
    }
</script>

<style>
    .AddressItem .index, 
    .AddressItem .ctrls, 
    .AddressItem .first, 
    .AddressItem .second, 
    .AddressItem .third {
        float: left;
        width: 25%;
    }
    .AddressItem .ctrls, 
    .AddressItem .first,
    .AddressItem .second {
        padding-right: 10px;
    }
    .AddressItem .index {
        width: 50px;
    }

    .index .lbl {
        font-weight: 600;
    }
</style>

<div class="AddressItem clearfix">
    <div class="index">
        <div class="lbl">#{index + 1}</div>
        <ActionButton danger icon="far fa-trash" on:click={deleteItem} />
    </div>
    <div class="first">
        <SmartField type="input" name="name" label="Nome" value={data.name} on:fieldchange={onNameChange} />
    </div>
    <div class="second">
        <SmartField type="input" name="street" label="Via" value={data.street} on:fieldchange={onStreetChange} />
    </div>
    <div class="third">
        <SmartField type="input" name="city" label="Città" value={data.city} on:fieldchange={onCityChange} />
    </div>
</div>